var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redirect-page"},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"redirect-loader"},[_c('img',{attrs:{"src":require("./../../assets/logos/LineUp_Logo_Animado.gif"),"alt":"LineUp Tickets"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }